import firebase from 'firebase/app';
import 'firebase/firestore';

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDVkHQYNZ2YqiNpof4eXkh3kKZYOGiPBOI",
  authDomain: "mzas-admin.firebaseapp.com",
  projectId: "mzas-admin",
  storageBucket: "mzas-admin.appspot.com",
  messagingSenderId: "617414783949",
  appId: "1:617414783949:web:c83e678678444bca26ca84",
  measurementId: "G-561P39Z0ZZ"
});

const firestore = firebaseApp.firestore();

export {firestore};
